/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { isAndroid, isIos, isSafari } from '../../services/ClientService';
import {
  getGoToIosAppUrl,
  getGoToAndroidAppUrl,
  StoreOS,
} from '../../services/UrlService';
import { SmartBanner } from './SmartBanner';
export interface BannerProps {
  author: string;
  buttonText: string;
  price: string;
  logo: string;
  storeText: string;
  title: string;
  link: string;
}
type DefaultStoreProps = Omit<BannerProps, 'storeText' | 'link'>;

const messages = defineMessages({
  free: {
    id: 'mobileJoinPage.banner.free',
  },
  onTheAppStore: {
    id: 'mobileJoinPage.banner.appStore',
  },
  onThePlayStore: {
    id: 'mobileJoinPage.banner.playStore',
  },
  view: {
    id: 'mobileJoinPage.banner.view',
  },
});

export const AppBanner: React.FC = () => {
  const { formatMessage: f } = useIntl();
  if (!(isAndroid || (isIos && !isSafari))) {
    return null;
  }
  const store = isIos ? StoreOS.IOS : StoreOS.ANDROID;

  const defaultStoreData: DefaultStoreProps = {
    author: 'GoTo Technologies USA, Inc.',
    buttonText: f(messages.view),
    price: f(messages.free),
    logo: `${process.env.PUBLIC_URL}/static/media/goto-favicon.svg`,
    title: 'GoTo',
  };

  const StoreData: { [key in StoreOS]: BannerProps } = {
    [StoreOS.IOS]: {
      ...defaultStoreData,
      storeText: f(messages.onTheAppStore),
      link: getGoToIosAppUrl(),
    },
    [StoreOS.ANDROID]: {
      ...defaultStoreData,
      storeText: f(messages.onThePlayStore),
      link: getGoToAndroidAppUrl(),
    },
  };

  return <SmartBanner {...StoreData[store]} />;
};
